import { useTheme } from '@emotion/react';
import { IconArrowOut } from '@hubble/icons/web';
import { useState } from 'react';
import { Flex } from '../Flex/index.js';
import { getFileUploaderCopy } from './i18n.js';
import { DropzoneWrapper, FlexWrapper, SmallDeviceContent, WideDeviceContent } from './styles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const DROP_EFFECT = 'copy';
const EFFECT_ALLOWED = 'copyMove';
const Dropzone = ({
  disabled,
  error,
  onClick,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
  onDragStart,
  ['data-testid']: dataTestId
}) => {
  const [dropDepth, setDropDepth] = useState(0);
  const {
    translate
  } = useTheme();
  const {
    BROWSE_FILES,
    DRAG_N_DROP
  } = getFileUploaderCopy(translate);
  const handleDragEnter = e => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = DROP_EFFECT;
    setDropDepth(dropDepth + 1);
    onDragEnter && onDragEnter(e);
  };
  const handleDragLeave = e => {
    e.preventDefault();
    e.stopPropagation();
    setDropDepth(dropDepth - 1);
    onDragLeave && onDragLeave(e);
  };
  const handleDragOver = e => {
    e.preventDefault();
    e.stopPropagation();
    onDragOver && onDragOver(e);
  };
  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    setDropDepth(0);
    onDrop && onDrop(e);
  };
  const handleDragStart = e => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.effectAllowed = EFFECT_ALLOWED;
    onDragStart && onDragStart(e);
  };
  const handleKeyDown = event => {
    if (event.key === 'Enter') onClick();
  };
  return jsx(DropzoneWrapper, {
    "data-testid": dataTestId,
    disabled: disabled,
    error: error,
    onClick: !disabled ? onClick : null,
    onDragStart: !disabled ? handleDragStart : null,
    dropzone: dropDepth > 0,
    onDragEnter: !disabled ? handleDragEnter : null,
    onDragLeave: !disabled ? handleDragLeave : null,
    onDragOver: !disabled ? handleDragOver : null,
    onDrop: !disabled ? handleDrop : null,
    onKeyDown: !disabled ? handleKeyDown : null,
    tabIndex: !disabled ? 0 : null,
    children: jsxs(FlexWrapper, {
      children: [jsx(Flex, {
        alignItems: "center",
        minWidth: 0,
        children: jsx(IconArrowOut, {
          color: disabled && 'inherit'
        })
      }), jsxs(Flex, {
        flex: "1",
        children: [jsx(SmallDeviceContent, {
          color: disabled && 'inherit',
          children: BROWSE_FILES
        }), jsx(WideDeviceContent, {
          color: disabled && 'inherit',
          children: DRAG_N_DROP(disabled)
        })]
      })]
    })
  });
};

export { Dropzone };
